'use strict';

var React = require('react');

var SvgPauseMinor = function SvgPauseMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 13a1 1 0 1 0 2 0v-6a1 1 0 1 0-2 0v6zm-4 0a1 1 0 1 0 2 0v-6a1 1 0 0 0-2 0v6zm3-11a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  }));
};

exports.SvgPauseMinor = SvgPauseMinor;
